export function getFileName(pathMateri: string | File): string {
  if (!pathMateri) return '';
  if (typeof pathMateri === 'string') {
    const urlWithoutQuery = pathMateri.split('?')[0];
    return urlWithoutQuery.split('/').pop() || pathMateri;
  }
  return pathMateri.name;
}